import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { DemoozLocalStorageService } from '@demooz/services';
import { DataService, AuthService, OperationService, WidgetService } from '@app/services';
import { Operation, Widget } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class OperationGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private demoozLocalStorageService : DemoozLocalStorageService,        
        private dataService : DataService,
        private authService : AuthService,
        private operationService : OperationService,
        private widgetService : WidgetService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {                     
            return this.checkOperation(route, route.queryParamMap.get('o'));
    }
        
    async checkOperation(route: ActivatedRouteSnapshot, operationID: string|null){    
        if(this.dataService.operation.value === null){
            
            let operation: any = null;
       
            if(operationID === null){
                operationID = this.demoozLocalStorageService.get('operationID');
            }

            if(operationID){
                operation = await this.operationService.fetchOperation(operationID);
            }
           
            if(operation){
                
                let isPageOperationFinished = (route.routeConfig?.path === 'operation/finished');
                this.demoozLocalStorageService.set('operationID', operation.ID);                    
                this.dataService.operation = new Operation(operation);                   
                await this.operationService.init();
                
                if(["over", "archived"].indexOf(operation.state) !== -1){    
                    this.authService.logout(false);   
                    if(isPageOperationFinished){
                        return true;
                    }
                    else{
                        return this.router.parseUrl('operation/finished');
                    }   
                    
                }
                else{   
                    if(operation.widgetID){
                        let widget = await this.widgetService.fetchWidget(operation.widgetID);
                        if(widget){
                            this.dataService.widget = new Widget(widget);
                        }
                    }          
                    if(isPageOperationFinished){   
                        return this.router.parseUrl('home');
                    }
                    else{       
                        return true;
                    }
                }
            }
            else{             
                this.demoozLocalStorageService.delete('operationID');
                this.authService.logout(false);
                this.operationService.resetCSS();
                return this.router.parseUrl('operation/unknown');
            }
        }
        else{            
            return true;
        }
    }
}
